


























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-modal-content-wrapper',
  components: {},
})
export default class ModalContentWrapper extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) show: boolean;
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: '' }) readonly bodyClass: string;

  // DATA
  // LIFECYCLE
  // created() { }
  mounted() {
    if (this.show) {
      this.openModal();
    }
  }

  // updated () { }
  // destroyed () { }
  // COMPUTED
  // METHODS

  openModal() {
    this.$bvModal.show(this.componentId);
  }

  closeModal() {
    this.$bvModal.hide(this.componentId);
  }

  // WATCHERS
  @Watch('show')
  onShowChange(val) {
    console.log(val);
    if (val) {
      console.log('watch open modal');
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}
